import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { IUser } from '../../shared/models/user';
import { UserUtility } from '../../shared/utilities/user-utility';
import { Subscription } from 'rxjs';
import { materialSymbols } from '../../shared/constants/material-symbols';
import { ConfigurationService } from '../../shared/services/configuration.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss',
    standalone: false
})
export class DashboardComponent implements OnInit {

  currentUser: IUser | null = null;
  isCurrentUserCM: boolean = false;
  materialSymbols = materialSymbols;
  subscriptions: Subscription = new Subscription();
  maintenanceMessage: string | null = null;

  constructor(
    private _authService: AuthService,
    private _configService: ConfigurationService
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(this._authService.currentUserSubject.subscribe((user) => {
      this.currentUser = user;
      this.initialize();
    }));

    this.subscriptions.add(this._configService.getMaintenanceMessage().subscribe({
      next: (response) => {
        if (response.success) {
          this.maintenanceMessage = response.content;
        } else {
          console.error('Failed to fetch maintenance message:', response.message);
        }
      },
      error: (error) => {
        console.error('Error fetching maintenance message:', error);
      }
    }));

  }

  initialize() {
    if(!this.currentUser) return;
    this.isCurrentUserCM = UserUtility.isCommitteeMember(this.currentUser);
  }
}
